export const API_URL = '/api'
export const PAGE_SIZE = 20
export const VERSION = import.meta.env.VITE_SITE_VERSION || 'dev'

export const USER_ROLES = {
  operatore_commerciale: { value: 'operatore_commerciale', label: 'Operatore commerciale' },
  operatore: { value: 'operatore', label: 'Operatore' },
  supervisore: { value: 'supervisore', label: 'Supervisore' },
  amministratore: { value: 'amministratore', label: 'Amministratore' },
  responsabile_cliente: { value: 'responsabile_cliente', label: 'Responsabile cliente' },
  cliente: { value: 'cliente', label: 'Cliente' },
} as const

export const USER_ROLES_UTENTI = [
  USER_ROLES.operatore_commerciale,
  USER_ROLES.operatore,
  USER_ROLES.supervisore,
  USER_ROLES.amministratore,
] as const

export const USER_ROLES_CLIENTI = [USER_ROLES.responsabile_cliente, USER_ROLES.cliente] as const

export const INTERVENTI_OPTIONS_TAB = {
  interventi: {
    value: 'interventi',
    label: 'Interventi',
    icon: 'list',
    link: '/interventi',
  },
  scadenze: {
    value: 'scadenze',
    label: 'Scadenze',
    icon: 'event',
    link: '/interventi-scadenze',
  },
  programmazione: {
    value: 'programmazione',
    label: 'Programmazione',
    icon: 'calendar_today',
    link: '/interventi-calendario',
  },
} as const

export const TIPI_BILANCIA = [
  { value: 'pesa_a_ponte', label: 'Pesa a ponte' },
  { value: 'pesetta', label: 'Pesetta' },
  { value: 'bilancina', label: 'Bilancina' },
]

export const TIPI_BILANCIA_EM = [
  { value: 'pesa_elettronica', label: 'Pesa elettronica' },
  { value: 'pesa_meccanica', label: 'Pesa meccanica' },
]

export const UNITA_DI_MISURA = [
  { value: 'kg', label: 'Kilogrammi' },
  { value: 'ton', label: 'Tonnellate' },
]

export const CLASSI_DI_PRECISIONE = [
  { value: 'I', label: 'Classe I' },
  { value: 'II', label: 'Classe II' },
  { value: 'III', label: 'Classe III' },
  { value: 'IIII', label: 'Classe IIII' },
]

export const TIPI_INTERVENTO = [
  { value: 'verifica_periodica', label: 'Verifica periodica' },
  { value: 'rapporto_taratura', label: 'Rapporto di taratura' },
]

export const STATI_INTERVENTO = [
  { value: 'richiesto', label: 'Richiesto' },
  { value: 'programmato', label: 'Programmato' },
  { value: 'eseguito', label: 'Eseguito' },
  { value: 'riesaminato', label: 'Riesaminato' },
  { value: 'esportato', label: 'Esportato' },
  { value: 'trasmesso', label: 'Trasmesso' },
  { value: 'invalido', label: 'Invalido' },
  { value: 'non_eseguito', label: 'Non eseguito' },
  { value: 'annullato', label: 'Annullato' },
]

export const ESITI = [
  { value: 'positivo', label: 'Positivo' },
  { value: 'negativo', label: 'Negativo' },
]

export const ESITI_RIESAME = [
  { value: 'conforme', label: 'Conforme' },
  { value: 'invalido', label: 'Invalido' },
]

export const STATI_ESPORTAZIONE = [
  { value: 'creata', label: 'Creata' },
  { value: 'esportata', label: 'Esportata' },
  { value: 'trasmessa', label: 'Trasmessa' },
]

export const CAMPI_STORICO = [
  { value: 'data_richiesta', label: 'Data richiesta' },
  { value: 'data_intervento', label: 'Data intervento' },
  { value: 'esito', label: 'Esito' },
  { value: 'esito_riesame', label: 'Esito riesame' },
]

export const STATI_PROPOSTA = [
  { value: 'inviata', label: 'Inviata' },
  { value: 'sollecitata', label: 'Sollecitata' },
  { value: 'scaduta', label: 'Scaduta' },
  { value: 'prenotata', label: 'Prenotata' },
  { value: 'rifiutata', label: 'Rifiutata' },
  { value: 'annullata', label: 'Annullata' },
  { value: 'accettata', label: 'Accettata' },
]

export const STATI_PROPOSTA_LOOKUP = {
  inviata: { value: 'inviata', label: 'Inviata' },
  sollecitata: { value: 'sollecitata', label: 'Sollecitata' },
  scaduta: { value: 'scaduta', label: 'Scaduta' },
  prenotata: { value: 'prenotata', label: 'Prenotata' },
  rifiutata: { value: 'rifiutata', label: 'Rifiutata' },
  annullata: { value: 'annullata', label: 'Annullata' },
  accettata: { value: 'accettata', label: 'Accettata' },
} as const
